// extracted by mini-css-extract-plugin
export default {"pageLayout":"BiopharmaGroups-module__pageLayout___w5nRP"};